import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import _ from 'lodash'

import { postFormWithImage, resetForm } from '../../actions'

class AddOwner extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      bits_owner_id: '',
      name: '',
      tel: '',
      contact_name: '',
      contact_tel: '',
      address: '',
      email: '',
      business_hours: '',
      hp_url: '',
      memo: '',
      image: '',
      image_url: '',
      image_error: ''
    }
  }

  componentDidMount () {
    this.props.resetForm()
  }

  _handleContentChange (key, e) {
    this.setState({ [key]: e.target.value })
  }

  async _handleImageChange (e) {
    const image = e.target.files[0]
    if (image) {
      if (
        (image.type === 'image/png' || image.type === 'image/jpeg' || image.type === 'image/jpeg') &&
        (image.name.indexOf('png') > 0 || image.name.indexOf('jpeg') > 0 || image.name.indexOf('jpg') > 0)
      ) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.setState({image_url: e.target.result})
        }
        reader.readAsDataURL(e.target.files[0])
        this.setState({ image })
      } else {
        this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  _handleFormSubmit (e) {
    e.preventDefault()
    if (!this.props.post.loading) {
      const data = _.omit(this.state, ['image', 'image_error', 'image_url'])
      const redirect = function () {
        this.props.history.push('/owners')
      }
      this.props.postFormWithImage('owners', data, this.state.image, redirect.bind(this))
    }
  }

  _resetImage () {
    this.setState({ image: '', image_url: '' })
    document.getElementById('image').value = ''
  }

  _renderImageLabel () {
    if (this.state.image_url) {
      return (
        <div className="label_container">
          <label className="image_input_label image_selected" htmlFor="image">
            <img className="img-responsive" src={this.state.image_url} alt=""/>
          </label>
          <div className="delete_container" onClick={this._resetImage.bind(this)}>
            <span></span>
            <span></span>
          </div>
        </div>
      )
    }
    return (
      <div className="label_container">
        <label className="image_input_label image_blank" htmlFor="image">
          <svg className="add" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
        </label>
      </div>
    )
  }

  _renderForm () {
    // if (!this.props.push.loading) {
    return (
      <form onSubmit={ this._handleFormSubmit.bind(this) }>
        <div className="input-group flex column">
          <label className="required" htmlFor="title">BITSオーナーID</label>
          <input
            type="text"
            id="bits_owner_id"
            className="medium_input"
            placeholder='BITSオーナーID'
            value={this.state.bits_owner_id}
            onChange={this._handleContentChange.bind(this, 'bits_owner_id')}
          />
        </div>
        <div className="input-group flex column">
          <label className="label required" htmlFor="title">
            { this.props.isAgency ? '管理会社' : 'オーナー名' }
          </label>
          <input
            type="text"
            id="name"
            className="medium_input"
            placeholder={ this.props.isAgency ? '管理会社' : 'オーナー名' }
            value={this.state.name}
            onChange={this._handleContentChange.bind(this, 'name')}
            required
          />
        </div>

        <div className="input-group flex column">
          <label className="label required" htmlFor="title">電話番号<small>（ハイフンなし）</small></label>
          <input
            type="tel"
            id="name"
            className="small_input"
            placeholder="電話番号"
            value={this.state.tel}
            onChange={this._handleContentChange.bind(this, 'tel')}
            required
          />
        </div>
        {
          this.props.isAgency
            ? [
              <div className="input-group flex column" key="contact_name">
                <label className="label" htmlFor="title">担当者名</label>
                <input
                  type="text"
                  id="name"
                  className="medium_input"
                  placeholder="担当者名"
                  value={this.state.contact_name}
                  onChange={this._handleContentChange.bind(this, 'contact_name')}
                />
              </div>,
              <div className="input-group flex column" key="contact_tel">
                <label className="label" htmlFor="title">担当者の電話番号<small>（ハイフンなし）</small></label>
                <input
                  type="tel"
                  id="name"
                  className="small_input"
                  placeholder="担当者の電話番号"
                  value={this.state.contact_tel}
                  onChange={this._handleContentChange.bind(this, 'contact_tel')}
                />
              </div>
            ]
            : null
        }

        <div className="input-group flex column">
          <label className="label required" htmlFor="title">住所</label>
          <input
            type="text"
            id="name"
            className="large_input"
            placeholder="住所"
            value={this.state.address}
            onChange={this._handleContentChange.bind(this, 'address')}
            required
          />
        </div>

        <div className="input-group flex column">
          <label className="label required" htmlFor="title">メールアドレス</label>
          <input
            type="email"
            id="name"
            className="medium_input"
            placeholder="メールアドレス"
            value={this.state.email}
            onChange={this._handleContentChange.bind(this, 'email')}
            required
          />
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="title">営業時間・定休日</label>
          <input
            type="text"
            id="name"
            className="large_input"
            placeholder="営業時間・定休日"
            value={this.state.business_hours}
            onChange={this._handleContentChange.bind(this, 'business_hours')}
          />
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="title">ホームページ</label>
          <input
            type="url"
            id="name"
            className="medium_input"
            placeholder="管理会社ホームページ"
            value={this.state.hp_url}
            onChange={this._handleContentChange.bind(this, 'hp_url')}
          />
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="image">
            画像
            <span className="smallest">（JPEG・PNGファイルのみ）</span>
          </label>
          <div className="image_input_container flex">
            { this._renderImageLabel() }
            <div>
              <div className="image_error small">{ this.state.image_error }</div>
              <input
                type="file"
                id="image"
                onChange={this._handleImageChange.bind(this)}
              />
            </div>
          </div>
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="title">メモ</label>
          <textarea
            id="name"
            className="large_input"
            value={this.state.memo}
            onChange={this._handleContentChange.bind(this, 'memo')}
          >
          </textarea>
        </div>

        <div className="button_container flex justify-center">
          <Link to="/owners" className="btn cancel_btn">キャンセル</Link>
          <button className="btn submit_btn" type="submit">保存</button>
        </div>
      </form>
    )
    // }
    // return <Loader classname="loader_dot_circle"/>
  }

  render () {
    // if (this.props.push && this.props.push.postSuccess) {
    //   return <Redirect to='/push' />
    // }
    return (
      <section className="owner_form add_form">
        <h4 className="page_title bold">
          { this.props.isAgency ? '管理会社追加' : 'オーナー追加' }
        </h4>
        { this._renderForm() }
      </section>
    )
  }
}

function mapStateToProps ({ post }) {
  return { post }
}

export default withRouter(connect(mapStateToProps, { postFormWithImage, resetForm })(AddOwner))
// export default AddOwner



// WEBPACK FOOTER //
// ./src/components/Owners/AddOwner.js